/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {approveAccountIntegration} from '../api'

export const useMutationApproveAccountIntegration = createReactQueryMutationHook('approveAccountIntegration', approveAccountIntegration)
